import * as React from "react";

class Home extends React.Component<{}, {}> {
    render(): JSX.Element {
        return (
            <section id="intro">
                <h2>Welcome to the new toolbox!</h2>
                <p>
                    If you run into issues, please ask a globalmod for help or ask at the MODs Telegram Channel.
                </p>
                
            </section>
        );
    }
}

export default Home;
